import React, { useEffect, useState } from "react";
import { Layout, Menu, Tabs, Button, Select, message } from "antd";
import {
  AndroidOutlined,
  BarChartOutlined,
  CameraOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import "./postman.css";
import config from "../../config";
import { authHeader } from "../../_helpers";
import moment from "moment";

const { Sider, Content } = Layout;
const { Option } = Select;
const { SubMenu } = Menu;

const baseUrl = config.apiGateway.baseUrl;

const apiCollection = {
  cctvCommand: {
    apiName: "Center fetching all data with specific details",
    method: "GET",
    url: `https://r6xuc56rug.execute-api.ap-south-1.amazonaws.com/prod/get_masterids`,
    // description:
    //   "This API is used to fetch Arrest Register report data city-wise based on selected date range.",
    bodyTemplate: {
      page_num: "",
    },
    bodyDescription: {
      page_num: "The page number for paginated results.",
    },
  },
  cctvmasterId: {
    apiName: "fetching latest data by passing masterID",
    method: "GET",
    url: `https://r6xuc56rug.execute-api.ap-south-1.amazonaws.com/prod/`,
    // description:
    //   "This API is used to fetch Arrest Register report data city-wise based on selected date range.",
    bodyTemplate: {
      master_id: "",
    },
    bodyDescription: {
      master_id: "The master ID of the detected criminal.",
    },
  },
  adminArrestListReport: {
    apiName: "Admin-Arrest list api ",
    method: "POST",
    url: `${baseUrl}/arrest/getArrestReport`,
    // description:
    //   "This API is used to fetch Arrest Register report data city-wise based on selected date range.",
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: DD-MM-YYYY)",
      endDate: "End date of report (Format: DD-MM-YYYY)",
      cityId: "City ID to filter arrest register data",
    },
  },
  adminArrestCountReport: {
    apiName: "Admin-Arrest count api ",
    method: "POST",
    url: `${baseUrl}/criminal/getArrestCountCityWise`,
    // description:
    //   "This API is used to fetch Arrest Register report data city-wise based on selected date range.",
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: DD-MM-YYYY)",
      endDate: "End date of report (Format: DD-MM-YYYY)",
      cityId: "City ID to filter arrest register data",
    },
  },
  psArrestListReport: {
    apiName: "Police Side-Arrest list api ",
    method: "POST",
    url: `${baseUrl}/arrest/getArrestReport`,
    // description:
    //   "This API is used to fetch Arrest Register report data district-wise based on selected date range.",
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: DD-MM-YYYY)",
      endDate: "End date of report (Format: DD-MM-YYYY)",
      id: "District ID to filter arrest register data",
    },
  },
  adminTwoPlusWithinBoundaryReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/get2plusNewArophiList`,
    // description:
    //   "This API is used to fetch two plus report data city-wise based on selected date range.",
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusWithinBoundaryCountReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी-सांख्यिकी",
    method: "GET",
    url: `${baseUrl}/criminal/get2lusArophiCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusNewCrimeReport: {
    apiName: "आरोपी विरुद्ध नव्याने दाखल गुन्ह्यांची आकडेवारी",
    method: "GET",
    url: `${baseUrl}/criminal/get2lusNewArophiCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusNewCrimeWithinBoundarReport: {
    apiName:
      "पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiListCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusNewCrimeWithinBoundarCountReport: {
    apiName:
      "पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-सांख्यिकी",
    method: "GET",
    url: `${baseUrl}/criminal/get2lusNewListArophiCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusEnteredByReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-यादी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2PlusNewAropiPostBharaliList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusEnteredByCountReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-सांख्यिकी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusNewEnteredByCrimeReport: {
    apiName:
      "पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiPostBharaliList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminTwoPlusNewEnteredByCrimeCountReport: {
    apiName:
      "पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची- सांख्यिकी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusNewListPostBharaliCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveOngoingReport: {
    apiName: "चालु प्रतिबंधक कारवाई-यादी ",
    method: "POST",
    url: `${baseUrl}/criminal/OngoingPreventiveActionList`,
    bodyTemplate: {
      startDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveOngoingCountReport: {
    apiName: "चालु प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getOngoingPreventiveActionCount`,
    bodyTemplate: {
      startDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveCompletedReport: {
    apiName: "संपलेली प्रतिबंधक कारवाई-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getCompletedPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveCompletedCountReport: {
    apiName: "संपलेली प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getCompletedPreventiveActionsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
      rangeType: "custom",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveReport: {
    apiName: "प्रतिबंधक कारवाई-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
      rangeType: "custom",
      label: "admin",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  adminPreventiveCountReport: {
    apiName: "प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
      rangeType: "custom",
      label: "admin",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  adminPreventiveviolatedReport: {
    apiName: "प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionViolators`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
      rangeType: "custom",
      label: "admin",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  adminPreventiveviolatedCountReport: {
    apiName: "प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionViolatorsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
      rangeType: "custom",
      label: "admin",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  adminGunaReport: {
    apiName: "गुन्हा रजिस्टर-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getListGunaReportAdmin`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  adminGunaCountReport: {
    apiName: "गुन्हा रजिस्टर-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getCountGunaReportAdmin`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  crNumberReport: {
    apiName: "अदखलपात्र गुन्हा रजिस्टर-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/NcrList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  crNumberCountReport: {
    apiName: "अदखलपात्र गुन्हा रजिस्टर-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/NcrCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  noticeReport: {
    apiName: "नोटीस रजिस्टर-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/noticeList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  noticeCountReport: {
    apiName: "नोटीस रजिस्टर-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/noticeCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      city: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      city: "city ID to filter the data",
    },
  },
  accusedReport: {
    apiName: "आरोपी सांख्यिकी अहवाल-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getReports1`,
    bodyTemplate: {
      startDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  accusedNotReport: {
    apiName: " अद्याप चेक न केलेले आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/getReports4`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "end date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  appReport: {
    apiName: "एकूण अ‍ॅप वापरकर्ते",
    method: "GET",
    url: `${baseUrl}/criminal/getTotalAppUsersCount`,
    bodyTemplate: {
      role: "4",
      cityId: "",
    },
    bodyDescription: {
      role: "role",
      cityId: "city ID to filter the data",
    },
  },
  spotReport: {
    apiName: "स्पॉट अहवाल निहाय",
    method: "POST",
    url: `${baseUrl}/criminal/getReportAdminSpotvise`,
    bodyTemplate: {
      startDate: "",
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  gpsReport: {
    apiName: "आरोपी गस्त रीपोर्ट",
    method: "GET",
    url: `${baseUrl}/criminal/getGPSInformation`,
    bodyTemplate: {
      cityId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      cityId: "city ID to filter the data",
    },
  },
  policeOngoingPreventiveReport: {
    apiName: "चालु प्रतिबंधक कारवाई",
    method: "POST",
    url: `${baseUrl}/criminal/OngoingPreventiveActionListById`,
    bodyTemplate: {
      startDate: "",
      id: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      id: "User ID to filter the data",
    },
  },
  policecompletedPreventiveReport: {
    apiName: "संपलेली प्रतिबंधक कारवाई",
    method: "POST",
    url: `${baseUrl}/criminal/getCompletedPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      district: "",
      label: "ps",
      rangeType: "custom",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      district: "District ID to filter the data",
    },
  },
  policePreventiveReport: {
    apiName: "प्रतिबंधक कारवाई",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      district: "",
      rangeType: "custom",
      label: "ps",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      district: "District ID to filter the data",
    },
  },
  policeViolatedPreventive: {
    apiName: "प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionViolators`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      district: "",
      rangeType: "custom",
      label: "ps",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      district: "District ID to filter the data",
    },
  },
  policeGunaReport: {
    apiName: "गुन्हा रजिस्टर-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getGunaReportPoliceSide`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      district: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      district: "District ID to filter the data",
    },
  },
  policeGunaCountReport: {
    apiName: "गुन्हा रजिस्टर-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getGunareportByTitle`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      district: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      district: "District ID to filter the data",
    },
  },
  ncrpsReport: {
    apiName: "अदखलपात्र गुन्हा रजिस्टर",
    method: "POST",
    url: `${baseUrl}/criminal/NcrList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "District ID to filter the data",
    },
  },
  noticepsReport: {
    apiName: "नोटीस रजिस्टर",
    method: "POST",
    url: `${baseUrl}/criminal/noticeReport`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "District ID to filter the data",
    },
  },
  policegpsReport: {
    apiName: "आरोपी गस्त रीपोर्ट",
    method: "GET",
    url: `${baseUrl}/criminal/getGpsinformationPoliceStation`,
    bodyTemplate: {
      id: "",
    },
    bodyDescription: {
      id: "User ID to filter the data",
    },
  },
  accusedpsReport: {
    apiName: "अद्याप चेक न केलेले आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/getReports4`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "District ID to filter the data",
      id: "User ID to filter the data",
    },
  },
  spotPsReport: {
    apiName: "पोलीस स्टेशन Spot Vise लिस्ट",
    method: "POST",
    url: `${baseUrl}/spotservellience/getReportPoliceSpotvise`,
    bodyTemplate: {
      startDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      districtId: "District ID to filter the data",
    },
  },
  policePlusWithinBoundaryReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/get2plusNewArophiListPoliceStation`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      id: "District ID to filter the data",
    },
  },
  policePlusaccedReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/get2plusNewArophiByidList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      id: "District ID to filter the data",
    },
  },
  policeNewPlusWithinBoundaryReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiListPoliceStationCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
      direction: "DESC",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      id: "District ID to filter the data",
    },
  },
  policeNewPlusAccedReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiListByIdCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      id: "",
      direction: "DESC",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      id: "District ID to filter the data",
    },
  },
  // officer side
  officerGunaReport: {
    apiName: "गुन्हा रजिस्टर-यादी",
    key: "officer",
    method: "POST",
    url: `${baseUrl}/criminal/getListGunaReportByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "city ID to filter the data",
    },
  },
  officerGunaCountReport: {
    apiName: "गुन्हा रजिस्टर-सांख्यिकी",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/getCountGunaReportByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerncrReport: {
    apiName: "अदखलपात्र गुन्हा रजिस्टर-यादी",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/NcrList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtIds: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtIds: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerncrCountReport: {
    apiName: "अदखलपात्र गुन्हा रजिस्टर-सांख्यिकी",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/NcrCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtIds: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtIds: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerNoticeReport: {
    apiName: "नोटीस रजिस्टर-यादी",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/noticeListByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerNoticeReport: {
    apiName: "नोटीस रजिस्टर-सांख्यिकी",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/noticeCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerAccusedStatistical: {
    apiName: "आरोपी सांख्यिकी अहवाल",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/getStatisticalReport`,
    bodyTemplate: {
      startDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerappreport: {
    apiName: "एकूण अ‍ॅप वापरकर्ते",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/TotalAppUsersCountByRole`,
    bodyTemplate: {
      districtId: "",
    },
    bodyDescription: {
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerspotreport: {
    apiName: "स्पॉट अहवाल निहाय",
    method: "POST",
    key: "officer",
    url: `${baseUrl}/criminal/getReportSpotviseByRole`,
    bodyTemplate: {
      startDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data for example :[1,2]",
    },
  },
  officerPreventiveOngoingReport: {
    apiName: "चालु प्रतिबंधक कारवाई-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/OngoingPreventiveActionListByRole`,
    bodyTemplate: {
      startDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveOngoingCountReport: {
    apiName: "चालु प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getOngoingPreventiveActionCountByRole`,
    bodyTemplate: {
      startDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveCompletedReport: {
    apiName: "संपलेली प्रतिबंधक कारवाई-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getCompletedPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveCompletedCountReport: {
    apiName: "संपलेली प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getCompletedPreventiveActionsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveActionReport: {
    apiName: "प्रतिबंधक कारवाई-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionsList`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveCountReport: {
    apiName: " प्रतिबंधक कारवाई-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveviolatedReport: {
    apiName: "प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionViolators`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "districtId ID to filter the data",
    },
  },
  officerPreventiveviolatedCountReport: {
    apiName: "प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/getPreventiveActionViolatorsCount`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "city ID to filter the data",
    },
  },
  officerTwoPlusWithinBoundaryReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/getPlus2ArophiListByRole`,
    // description:
    //   "This API is used to fetch two plus report data district-wise based on selected date range.",
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusWithinBoundaryCountReport: {
    apiName: "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी-सांख्यिकी",
    method: "GET",
    url: `${baseUrl}/criminal/get2lusArophiCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusNewCrimeReport: {
    apiName: "आरोपी विरुद्ध नव्याने दाखल गुन्ह्यांची आकडेवारी",
    method: "GET",
    url: `${baseUrl}/criminal/get2lusNewArophiCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusNewCrimeWithinBoundarReport: {
    apiName:
      "पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiListCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusNewCrimeWithinBoundarCountReport: {
    apiName:
      "पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-सांख्यिकी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusNewListArophiCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusEnteredByReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-यादी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2PlusNewAropiPostBharaliListByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusEnteredByCountReport: {
    apiName: "पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-सांख्यिकी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusNewEnteredByCrimeReport: {
    apiName:
      "पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-यादी",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusArophiPostBharaliListByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  officerTwoPlusNewEnteredByCrimeCountReport: {
    apiName:
      "पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची- सांख्यिकी ",
    method: "POST",
    url: `${baseUrl}/criminal/get2lusNewListPostBharaliCountByRole`,
    bodyTemplate: {
      startDate: "",
      endDate: "",
      districtId: "",
    },
    bodyDescription: {
      startDate: "Start date of report (Format: YYYY-MM-DD)",
      endDate: "End date of report (Format: YYYY-MM-DD)",
      districtId: "district ID to filter the data",
    },
  },
  androidPatrolling: {
    apiName: "Patrolling API",
    method: "GET",
    url: `${baseUrl}/criminal/getCriminalsTableInfoByPetrolling`,
    bodyTemplate: {
      cityId: "",
      districtId: "",
    },
    bodyDescription: {
      cityId: "city ID to filter the data",
      districtId: "district ID to filter the data",
    },
  },
  NakabandiSearch: {
    apiName: "Nakabandi Super Search API",
    method: "GET",
    url: `${baseUrl}/criminal/getCriminalsTableInfobyName`,
    bodyTemplate: {
      search: "",
      id: "",
    },
    bodyDescription: {
      search: "search the data",
      id: "city ID to filter the data",
    },
  },
  androidWanted: {
    apiName: "Wanted",
    method: "GET",
    url: `${baseUrl}/criminal/getWantedType`,
    bodyTemplate: {
      wantedType: "",
      cityId: "",
    },
    bodyDescription: {
      wantedType:
        "(1: पाहिजे, 2: फरार, 3: मपोका कलम 68/69, 4: मपोका कलम 55, 5: मपोका कलम 56)",
      cityId: "city ID to filter the data",
    },
  },
  androidCriminalAlbum: {
    apiName: "Criminal Album",
    method: "GET",
    url: `${baseUrl}/criminal/getCriminalsImagesCityId`,
    bodyTemplate: {
      cityId: "",
      page: "0",
      size: "",
    },
    bodyDescription: {
      cityId: "city ID to filter the data",
      page: "page add like 0,1,2",
      size: "size add like 10,20",
    },
  },
  androidNews: {
    apiName: "News",
    method: "GET",
    url: `${baseUrl}/criminal/getNews`,
    bodyTemplate: {
      role: "",
    },
    bodyDescription: {
      role: "role like 4,8,9,10",
    },
  },
  androidHelp: {
    apiName: "Help",
    method: "GET",
    url: `${baseUrl}/criminal/getNews`,
    bodyTemplate: {
      role: "",
    },
    bodyDescription: {
      role: "role like 4,8,9,10",
    },
  },
  androidAbout: {
    apiName: "About",
    method: "GET",
    url: `${baseUrl}/criminal/getNews`,
    bodyTemplate: {
      role: "",
    },
    bodyDescription: {
      role: "role like 4,8,9,10",
    },
  },
  androidNearBy: {
    apiName: "Near By",
    method: "POST",
    url: `${baseUrl}/criminal/getNearByCriminals`,
    bodyTemplate: {
      km: "",
      poslat: "",
      poslng: "",
    },
    bodyDescription: {
      km: "kilometers ",
      poslat: "Latitude",
      poslng: "Longitude",
    },
  },
  androidCctv: {
    apiName: "Near By",
    method: "POST",
    url: `${baseUrl}/criminal/getNearByCCTV`,
    bodyTemplate: {
      km: "",
      poslat: "",
      poslng: "",
    },
    bodyDescription: {
      km: "kilometers ",
      poslat: "Latitude",
      poslng: "Longitude",
    },
  },
  criminalFaceSearch: {
    apiName: "Criminal Face Search",
    method: "POST",
    url: `${baseUrl}/criminal/face/search`,
    supportsImageUpload: true,
    imageUploadUrl: `${baseUrl}/face/face-img-upload`,
    autoFilledFields: ["filename", "s3_object", "s3_bucket"],
    bodyTemplate: {
      filename: "",
      s3_object: "",
      s3_bucket: "",
      top: "",
      threshold: "",
    },
    bodyDescription: {
      filename: "Auto-filled after image upload.",
      s3_object: "Auto-filled after image upload.",
      s3_bucket: "Auto-filled after image upload.",
      top: "Number of top matching results to return.",
      threshold: "Similarity threshold for face matching.",
    },
  },
};

const PostmanCollection = () => {
  const [method, setMethod] = useState("GET");
  const [url, setUrl] = useState("");
  const [bodyData, setBodyData] = useState({});
  const [rawBody, setRawBody] = useState("");
  const [response, setResponse] = useState("");
  const [status, setStatus] = useState("");
  const [apiDetails, setApiDetails] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const handleImageUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file || !apiDetails?.imageUploadUrl) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      message.error("Please select a valid image (jpeg, jpg, png, gif)");
      event.target.value = "";
      return;
    }

    setUploadingImage(true);
    setImagePreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append("profileImage", file);

    try {
      const res = await fetch(apiDetails.imageUploadUrl, {
        method: "POST",
        headers: {
          ...authHeader(),
        },
        body: formData,
      });
      const data = await res.json();

      if (!res.ok || data.error || data.err) {
        message.error(data.error || data.err || "Image upload failed");
        return;
      }

      setBodyData((prev) => ({
        ...prev,
        filename: data.filename || "",
        s3_object: data.s3_object || "",
        s3_bucket: data.s3_bucket || "",
      }));
      message.success("Image uploaded. S3 fields filled automatically.");
    } catch (error) {
      message.error("Image upload failed: " + error.message);
    } finally {
      setUploadingImage(false);
      event.target.value = "";
    }
  };

  /* Sidebar Click */
  const handleMenuClick = ({ key }) => {
    const selectedApi = apiCollection[key];

    if (selectedApi) {
      setMethod(selectedApi.method);
      setUrl(selectedApi.url);
      setBodyData(selectedApi.bodyTemplate || {});
      setApiDetails(selectedApi);
      setResponse("");
      setStatus("");
      setImagePreview(null);
    }
  };

  /* Send API */
  const handleSend = async () => {
    if (!url) {
      message.error("API URL is missing");
      return;
    }

    let parsedBody = null;

    if (method !== "GET") {
      try {
        parsedBody = rawBody ? JSON.parse(rawBody) : {};
        // setBodyData(parsedBody);
      } catch (err) {
        message.error("Invalid JSON format");
        return;
      }
    }

    try {
      let finalUrl = url;
      if (
        method === "GET" &&
        (apiDetails?.apiName ===
          "पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी-सांख्यिकी" ||
          apiDetails?.apiName ===
            "आरोपी विरुद्ध नव्याने दाखल गुन्ह्यांची आकडेवारी" ||
          apiDetails?.apiName ===
            "पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची-सांख्यिकी")
      ) {
        const { startDate, endDate, cityId } = bodyData;

        if (!startDate || !endDate || !cityId) {
          message.error("All fields are required");
          return;
        }

        finalUrl = `${url}/${startDate}/${endDate}/${cityId}`;
      }
      if (method == "GET" && apiDetails?.apiName === "एकूण अ‍ॅप वापरकर्ते") {
        const { role, cityId } = bodyData;
        finalUrl = `${url}/${role}/${cityId}`;
      }
      if (method == "GET" && apiDetails?.apiName === "आरोपी गस्त रीपोर्ट") {
        const { cityId, id } = bodyData;
        if (id) {
          finalUrl = `${url}/${id}`;
        } else {
          finalUrl = `${url}/${cityId}`;
        }
      }
      if (
        method == "GET" &&
        apiDetails?.apiName === "Center fetching all data with specific details"
      ) {
        const { page_num } = bodyData;
        if (page_num) {
          finalUrl = `${url}?page_num=${page_num}`;
        }
      }
      if (
        method === "GET" &&
        apiDetails?.apiName === "fetching latest data by passing masterID"
      ) {
        const { master_id } = bodyData;
        if (master_id) {
          finalUrl = `${url}get_basicinfo_pdf?master_id=${master_id}`;
        }
      }
      if (apiDetails?.key === "officer") {
        let { districtId, districtIds } = bodyData;

        if (districtId) {
          // If string like "[1912,1929,...]"
          if (typeof districtId === "string") {
            districtId = JSON.parse(districtId);
          }

          if (Array.isArray(districtId)) {
            // Ensure it is array
            bodyData.districtId = districtId.map((id) => parseInt(id, 10));
          } else {
            message.error("districtId must be an array");
            return;
          }
        }
        if (districtIds) {
          if (typeof districtIds === "string") {
            districtIds = JSON.parse(districtIds);
          }
          if (Array.isArray(districtIds)) {
            // Ensure it is array
            bodyData.districtIds = districtIds.map((id) => parseInt(id, 10));
          } else {
            message.error("districtIds must be an array");
            return;
          }
        }
      }
      if (apiDetails?.apiName === "Patrolling API") {
        const { cityId, districtId } = bodyData;
        finalUrl = `${url}/${cityId}/${districtId}`;
      }
      if (apiDetails?.apiName === "Nakabandi Super Search API") {
        const { search, id } = bodyData;
        finalUrl = `${url}/${id}/${search}`;
      }
      if (apiDetails?.apiName === "Wanted") {
        const { wantedType, cityId } = bodyData;
        finalUrl = `${url}/${wantedType}/${cityId}`;
      }
      if (apiDetails?.apiName == "Criminal Album") {
        const { cityId, page, size } = bodyData;
        finalUrl = `${url}/${cityId}/?page=${page}&size=${size}`;
      }
      if (apiDetails?.apiName == "News") {
        const { role } = bodyData;
        finalUrl = `${url}/${role}/2`;
      }
      if (apiDetails?.apiName == "Help") {
        const { role } = bodyData;
        finalUrl = `${url}/${role}/5`;
      }
      if (apiDetails?.apiName === "About") {
        const { role } = bodyData;
        finalUrl = `${url}/${role}/4`;
      }

      const start = Date.now();

      const res = await fetch(finalUrl, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...authHeader(),
        },
        body: method !== "GET" ? JSON.stringify(bodyData) : null,
      });

      const end = Date.now();
      const data = await res.json();

      setStatus(`${res.status} (${end - start} ms)`);
      setResponse(JSON.stringify(data, null, 2));
    } catch (error) {
      setResponse("Error: " + error.message);
      setStatus("Request Failed");
    }
  };

  useEffect(() => {
    const defaultApi = apiCollection.adminTwoPlusNewCrimeReport;

    if (defaultApi) {
      setMethod(defaultApi.method);
      setUrl(defaultApi.url);
      setBodyData(defaultApi.bodyTemplate || {});
      setApiDetails(defaultApi);
    }
  }, []);
  console.log("selectedApi", apiDetails);
  return (
    <Layout className="pm-layout">
      <Sider width={260} className="pm-sidebar">
        <div className="pm-logo">Collections</div>

        <Menu
          mode="inline"
          defaultSelectedKeys={["adminTwoPlusNewCrimeReport"]}
          onClick={handleMenuClick}
        >
          <SubMenu key="reports" icon={<BarChartOutlined />} title="Reports">
            <SubMenu key="adminReports" title="Admin Reports">
              <SubMenu key="plusreport" title="2 प्लस">
                <Menu.Item
                  key="adminTwoPlusNewCrimeReport"
                  icon={<FileTextOutlined />}
                >
                  आरोपी विरुद्ध नव्याने दाखल गुन्ह्यांची आकडेवारी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusWithinBoundaryReport"
                  icon={<FileTextOutlined />}
                >
                  पो.स्टे हद्दीत राहणारे 2 प्लस आरोपी-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusWithinBoundaryCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो.स्टे हद्दीत राहणारे 2 प्लस आरोपी-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusEnteredByReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusEnteredByCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusNewCrimeWithinBoundarReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल
                  असलेल्या आरोपींची- यादी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusNewCrimeWithinBoundarCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल
                  असलेल्या आरोपींची- सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusNewEnteredByCrimeReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा
                  दाखल असलेल्या आरोपींची- यादी
                </Menu.Item>
                <Menu.Item
                  key="adminTwoPlusNewEnteredByCrimeCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा
                  दाखल असलेल्या आरोपींची- सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="preventiveReport" title="प्रतिबंधक कारवाई">
                <Menu.Item
                  key="adminPreventiveOngoingReport"
                  icon={<FileTextOutlined />}
                >
                  चालु प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveOngoingCountReport"
                  icon={<FileTextOutlined />}
                >
                  चालु प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveCompletedReport"
                  icon={<FileTextOutlined />}
                >
                  संपलेली प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveCompletedCountReport"
                  icon={<FileTextOutlined />}
                >
                  संपलेली प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveCountReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveviolatedReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminPreventiveviolatedCountReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="GunaReports" title="गुन्हा रजिस्टर">
                <Menu.Item key="adminGunaReport" icon={<FileTextOutlined />}>
                  गुन्हा रजिस्टर अहवाल-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminGunaCountReport"
                  icon={<FileTextOutlined />}
                >
                  गुन्हा रजिस्टर अहवाल-आकडेवारी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="arestReports" title="अटक रजिस्टर">
                <Menu.Item
                  key="adminArrestListReport"
                  icon={<FileTextOutlined />}
                >
                  अटक रजिस्टर अहवाल-यादी
                </Menu.Item>
                <Menu.Item
                  key="adminArrestCountReport"
                  icon={<FileTextOutlined />}
                >
                  अटक रजिस्टर अहवाल-आकडेवारी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="crNumber" title="अदखलपात्र गुन्हा रजिस्टर">
                <Menu.Item key="crNumberReport" icon={<FileTextOutlined />}>
                  अदखलपात्र गुन्हा रजिस्टर-यादी
                </Menu.Item>
                <Menu.Item
                  key="crNumberCountReport"
                  icon={<FileTextOutlined />}
                >
                  अदखलपात्र गुन्हा रजिस्टर-सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="notice" title="नोटीस रजिस्टर">
                <Menu.Item key="noticeReport" icon={<FileTextOutlined />}>
                  नोटीस रजिस्टर-यादी
                </Menu.Item>
                <Menu.Item key="noticeCountReport" icon={<FileTextOutlined />}>
                  नोटीस रजिस्टर-सांख्यिकी
                </Menu.Item>
              </SubMenu>

              <Menu.Item key="accusedReport" icon={<FileTextOutlined />}>
                आरोपी सांख्यिकी अहवाल
              </Menu.Item>
              <Menu.Item key="gpsReport" icon={<FileTextOutlined />}>
                आरोपी गस्त रीपोर्ट
              </Menu.Item>
              <Menu.Item key="accusedNotReport" icon={<FileTextOutlined />}>
                अद्याप चेक न केलेले आरोपी
              </Menu.Item>
              <Menu.Item key="appReport" icon={<FileTextOutlined />}>
                एकूण अ‍ॅप वापरकर्ते
              </Menu.Item>
              <Menu.Item key="spotReport" icon={<FileTextOutlined />}>
                स्पॉट अहवाल निहाय
              </Menu.Item>
            </SubMenu>
            <SubMenu key="policeReports" title="Police Side Reports">
              <SubMenu key="psPlusReport" title="२ प्लस अहवाल">
                <SubMenu title="2 प्लस" key="towplus">
                  <Menu.Item key="policePlusWithinBoundaryReport">
                    पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी
                  </Menu.Item>
                  <Menu.Item key="policePlusaccedReport">
                    पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी
                  </Menu.Item>
                </SubMenu>
                <SubMenu title="२ प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची यादी">
                  <Menu.Item key="policeNewPlusWithinBoundaryReport">
                    पो. स्टे हद्दीत राहणारे 2 प्लस आरोपी
                  </Menu.Item>
                  <Menu.Item key="policeNewPlusAccedReport">
                    पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी
                  </Menu.Item>
                </SubMenu>
              </SubMenu>
              <SubMenu key="policePreventive" title="प्रतिबंधक कारवाई">
                <Menu.Item
                  key="policeOngoingPreventiveReport"
                  icon={<FileTextOutlined />}
                >
                  चालु प्रतिबंधक कारवाई
                </Menu.Item>
                <Menu.Item
                  key="policecompletedPreventiveReport"
                  icon={<FileTextOutlined />}
                >
                  संपलेली प्रतिबंधक कारवाई
                </Menu.Item>
                <Menu.Item
                  key="policePreventiveReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाई
                </Menu.Item>
                <Menu.Item
                  key="policeViolatedPreventive"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी
                </Menu.Item>
              </SubMenu>
              <SubMenu title="गुन्हा रजिस्टर" key="psGuns">
                <Menu.Item key="policeGunaReport">
                  गुन्हा रजिस्टर-यादी
                </Menu.Item>
                <Menu.Item
                  key="policeGunaCountReport"
                  icon={<FileTextOutlined />}
                >
                  गुन्हा रजिस्टर-सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="psArrestListReport" icon={<FileTextOutlined />}>
                अटक रजिस्टर अहवाल-यादी
              </Menu.Item>
              <Menu.Item key="policegpsReport" icon={<FileTextOutlined />}>
                आरोपी गस्त रीपोर्ट
              </Menu.Item>
              <Menu.Item key="ncrpsReport" icon={<FileTextOutlined />}>
                अदखलपात्र गुन्हा रजिस्टर
              </Menu.Item>
              <Menu.Item key="noticepsReport" icon={<FileTextOutlined />}>
                नोटीस रजिस्टर
              </Menu.Item>
              <Menu.Item key="accusedpsReport" icon={<FileTextOutlined />}>
                अद्याप चेक न केलेले आरोपी
              </Menu.Item>
              <Menu.Item key="spotPsReport" icon={<FileTextOutlined />}>
                पोलीस स्टेशन Spot Vise लिस्ट
              </Menu.Item>
            </SubMenu>
            <SubMenu key="officer" title="Officer Side Reports">
              <SubMenu key="officerplusreport" title="2 प्लस">
                <Menu.Item
                  key="officerTwoPlusNewCrimeReport"
                  icon={<FileTextOutlined />}
                >
                  आरोपी विरुद्ध नव्याने दाखल गुन्ह्यांची आकडेवारी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusWithinBoundaryReport"
                  icon={<FileTextOutlined />}
                >
                  पो.स्टे हद्दीत राहणारे 2 प्लस आरोपी-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusWithinBoundaryCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो.स्टे हद्दीत राहणारे 2 प्लस आरोपी-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusEnteredByReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusEnteredByCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे 2 प्लस आरोपी-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusNewCrimeWithinBoundarReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल
                  असलेल्या आरोपींची- यादी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusNewCrimeWithinBoundarCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत राहणारे २ प्लस आरोपींवर नव्याने गुन्हा दाखल
                  असलेल्या आरोपींची- सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusNewEnteredByCrimeReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा
                  दाखल असलेल्या आरोपींची- यादी
                </Menu.Item>
                <Menu.Item
                  key="officerTwoPlusNewEnteredByCrimeCountReport"
                  icon={<FileTextOutlined />}
                >
                  पो. स्टे हद्दीत गुन्हे करणारे २ प्लस आरोपींवर नव्याने गुन्हा
                  दाखल असलेल्या आरोपींची- सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="officerpreventiveReport" title="प्रतिबंधक कारवाई">
                <Menu.Item
                  key="officerPreventiveOngoingReport"
                  icon={<FileTextOutlined />}
                >
                  चालु प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveOngoingCountReport"
                  icon={<FileTextOutlined />}
                >
                  चालु प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveCompletedReport"
                  icon={<FileTextOutlined />}
                >
                  संपलेली प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveCompletedCountReport"
                  icon={<FileTextOutlined />}
                >
                  संपलेली प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveActionReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाई-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveCountReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाई-सांख्यिकी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveviolatedReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerPreventiveviolatedCountReport"
                  icon={<FileTextOutlined />}
                >
                  प्रतिबंधक कारवाईचे उल्लंघन केलेल्या आरोपींची यादी-सांख्यिकी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="officerGunaReports" title="गुन्हा रजिस्टर">
                <Menu.Item key="officerGunaReport" icon={<FileTextOutlined />}>
                  गुन्हा रजिस्टर अहवाल-यादी
                </Menu.Item>
                <Menu.Item
                  key="officerGunaCountReport"
                  icon={<FileTextOutlined />}
                >
                  गुन्हा रजिस्टर अहवाल-आकडेवारी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="officerNcr" title="अदखलपात्र गुन्हा रजिस्टर">
                <Menu.Item key="officerncrReport">
                  अदखलपात्र गुन्हा रजिस्टर-यादी
                </Menu.Item>
                <Menu.Item key="officerncrCountReport">
                  अदखलपात्र गुन्हा रजिस्टर-आकडेवारी
                </Menu.Item>
              </SubMenu>
              <SubMenu key="officerNotice" title="नोटीस रजिस्टर">
                <Menu.Item key="officerNoticeReport">
                  नोटीस रजिस्टर-यादी
                </Menu.Item>
                <Menu.Item key="officerNoticCounteReport">
                  नोटीस रजिस्टर-आकडेवारी
                </Menu.Item>
              </SubMenu>
              <Menu.Item
                key="officerAccusedStatistical"
                icon={<FileTextOutlined />}
              >
                आरोपी सांख्यिकी अहवाल
              </Menu.Item>
              <Menu.Item key="officerappreport" icon={<FileTextOutlined />}>
                एकूण अ‍ॅप वापरकर्ते
              </Menu.Item>
              <Menu.Item key="officerspotreport" icon={<FileTextOutlined />}>
                स्पॉट अहवाल निहाय
              </Menu.Item>
            </SubMenu>
          </SubMenu>
          <SubMenu key="android" icon={<AndroidOutlined />} title="Android">
            <Menu.Item key="androidPatrolling" icon={<FileTextOutlined />}>
              Patrolling API
            </Menu.Item>
            <Menu.Item key="NakabandiSearch" icon={<FileTextOutlined />}>
              Nakabandi Super Search
            </Menu.Item>
            <Menu.Item key="androidWanted" icon={<FileTextOutlined />}>
              Wanted
            </Menu.Item>
            <Menu.Item key="androidCriminalAlbum" icon={<FileTextOutlined />}>
              Criminal Album
            </Menu.Item>
            <Menu.Item key="androidNearBy" icon={<FileTextOutlined />}>
              Near By
            </Menu.Item>
            <Menu.Item key="androidCctv" icon={<FileTextOutlined />}>
              CCTV
            </Menu.Item>
            <Menu.Item key="androidNews" icon={<FileTextOutlined />}>
              News
            </Menu.Item>
            <Menu.Item key="androidHelp" icon={<FileTextOutlined />}>
              Help
            </Menu.Item>
            <Menu.Item key="androidAbout" icon={<FileTextOutlined />}>
              About
            </Menu.Item>
             {/*<Menu.Item key="criminalFaceSearch" icon={<FileTextOutlined />}>
              Criminal Face Search
            </Menu.Item>
            */}
          </SubMenu>
          <SubMenu icon={<CameraOutlined />} key="cctv" title="CCTV api">
            <Menu.Item key="cctvCommand" icon={<FileTextOutlined />}>
              Center fetching all data with specific details
            </Menu.Item>
            <Menu.Item key="cctvmasterId" icon={<FileTextOutlined />}>
              Fetching latest data by passing masterID
            </Menu.Item>
           
          </SubMenu>
        </Menu>
      </Sider>

      <Layout className="pm-main-layout">
        <Content className="pm-content">
          {/* Request Bar */}
          {apiDetails && (
            <div className="pm-api-info">
              <h3>API Details</h3>
              <p>
                <strong>Api Name:</strong>
                {apiDetails.apiName}
              </p>
              <p>
                <strong>Endpoint:</strong> {apiDetails.url}
              </p>
              <p>
                <strong>Method:</strong> {apiDetails.method}
              </p>
              <p>{apiDetails.description}</p>
            </div>
          )}
          <div className="pm-request-bar">
            <Select
              value={method}
              onChange={setMethod}
              className={`pm-method pm-${method.toLowerCase()}`}
            >
              <Option value="GET">GET</Option>
              <Option value="POST">POST</Option>
              <Option value="PUT">PUT</Option>
              <Option value="DELETE">DELETE</Option>
            </Select>

            <input
              className="pm-url-input"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />

            <Button type="primary" onClick={handleSend}>
              Send
            </Button>
          </div>

          {/* Body Tab */}
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: "1",
                label: "Body",
                children: (
                  <div className="pm-json-structured">
                    {apiDetails?.supportsImageUpload && (
                      <div className="pm-image-upload">
                        <label className="pm-image-upload-label">
                          <input
                            type="file"
                            accept="image/jpeg,image/jpg,image/png,image/gif"
                            onChange={handleImageUpload}
                            disabled={uploadingImage}
                          />
                          <span className="pm-image-upload-btn">
                            {uploadingImage
                              ? "Uploading..."
                              : "Select face image"}
                          </span>
                        </label>
                        {imagePreview && (
                          <img
                            src={imagePreview}
                            alt="Selected face"
                            className="pm-image-preview"
                          />
                        )}
                        <div className="pm-json-description">
                          Upload an image first. filename, s3_object, and
                          s3_bucket will be filled automatically.
                        </div>
                      </div>
                    )}
                    {Object.keys(bodyData).map((key) => {
                      const isAutoFilled =
                        apiDetails?.autoFilledFields?.includes(key);

                      return (
                        <div key={key} className="pm-json-row">
                          <div className="pm-json-line">
                            <span className="pm-json-key">"{key}"</span>
                            <span className="pm-json-colon">:</span>
                            <input
                              className={`pm-json-value${
                                isAutoFilled ? " pm-json-readonly" : ""
                              }`}
                              value={bodyData[key] ?? ""}
                              readOnly={isAutoFilled}
                              onChange={(e) =>
                                setBodyData({
                                  ...bodyData,
                                  [key]: e.target.value,
                                })
                              }
                            />
                          </div>
                          {apiDetails?.bodyDescription?.[key] && (
                            <div className="pm-json-description">
                              {apiDetails.bodyDescription[key]}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ),
              },
            ]}
          />

          {/* Response */}
          {/* Response */}
          <div className="pm-response">
            <div className="pm-response-header">
              <div className="pm-response-left">
                <span className="pm-response-title">Response</span>

                {status && (
                  <span
                    className={`pm-status-badge ${
                      status.startsWith("2")
                        ? "pm-success"
                        : status.startsWith("4") || status.startsWith("5")
                        ? "pm-error"
                        : "pm-info"
                    }`}
                  >
                    {status}
                  </span>
                )}
              </div>

              {response && (
                <Button
                  size="small"
                  onClick={() => {
                    navigator.clipboard.writeText(response);
                    message.success("Copied to clipboard");
                  }}
                >
                  Copy
                </Button>
              )}
            </div>

            <div className="pm-response-body">
              {response ? (
                <pre>{response}</pre>
              ) : (
                <div className="pm-empty-response">
                  No response yet. Click <strong>Send</strong> to test API.
                </div>
              )}
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PostmanCollection;
